import React from 'react'

export default function useTeam( initMembers = [], onTalk )  {
    const [currentSpeech, setCurrentSpeech] = React.useState()
    const [members, setMembers] = React.useState( React.useMemo(() => {
        if (initMembers.length > 0) {
            return initMembers.map( m => ({
                ...m,
                id: 'team_member'+createID(),
                speech: 'Initial',
                delayIn :0.2,
                delayOut: 0,
                talk: function(speech, delayIn, delayOut) {
                    return {
                        id: this.id,
                        speech,
                        delayIn: delayIn ? delayIn : this.delayIn,
                        delayOut: delayOut ? delayOut : this.delayOut,
                    }
                }
            }))
        }
        return []
    }, [initMembers]) )
    const talk = ( ...speech) => {
        const newMap = new Map()
        speech.forEach( m => {
            newMap.set(m.id, {
                speech: m.speech,
                delayIn: m.delayIn,
                delayOut: m.delayOut,
            })
        })
        setCurrentSpeech(newMap)
    }
    return {
        members,
        currentSpeech,
        talk,
    }
}
function createID() {
    return '_' + Math.random().toString(36).substr(2, 9);
}

